module.exports = __webpack_public_path__ + "img/avatar.12241f59.png";